export function Logo() {
  return <span className="font-black">MovingData.org</span>;
}
